<div class="container" id="dealer">
  <div class="row">
    <div class="col-md-12">
      <h1 class="dealerName">{{profile.businessName}}</h1>
      <h2 class="dealerId">Dealer ID: {{profile.id}}</h2> <br>
      <div active="active">
        <ul class="nav nav-tabs">
          <li *ngIf="profile.bulkDataReport" class="uib-tab nav-item" heading="Dealer Report Search">
            <a [routerLink]="['report-search']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Dealer Report Search</a>
          </li>
          <li *ngIf="!profile.bulkDataReport" class="uib-tab nav-item" heading="Dealer Report Log">
            <a [routerLink]="['report-log']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Dealer Report Log</a>
          </li>
          <li class="uib-tab nav-item" heading="My Profile">
            <a [routerLink]="['my-profile']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">My Profile</a>
          </li>
          <li class="uib-tab nav-item" heading="Query Reports">
            <a [routerLink]="['query-reports']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Query Reports</a>
          </li>
        </ul>
        <div class="tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

